/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Show_Menu_LabelInputs */



/**
* | output |
* | --- |
* | "Show menu" |
*
* @param {Markers_Show_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_show_menu_label = /** @type {((inputs?: Markers_Show_Menu_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Show_Menu_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le menu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra menu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar menú")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メニューを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेनू दिखाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar menu")
	return /** @type {LocalizedString} */ ("Show menu")
});